import Vue from 'vue'

import RccTableColumn from './rcc-table-column.js'
import RccTable from './rcc-table.vue'

Vue.component('rcc-table-column', RccTableColumn)
Vue.component('rcc-table', RccTable)
